import { createSlice } from "@reduxjs/toolkit";
import {
    getBookById,
    getListOfBooksByAgeGroup,
    searchBooksByQuery
} from "../../controller/bookSelection/bookSelectionController";

const initialState = {
  isLoading: false,
  bookList: [],
  totalBook: 0,
  next: null,
  previous: null,
  error: null,
  selectedBook: null
};

const bookSelectionSlice = createSlice({
  name: "bookSelection",
  initialState,
  reducers: {
    setSelectedBook: (state, { payload }) => {
      state.selectedBook = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListOfBooksByAgeGroup.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getListOfBooksByAgeGroup.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.bookList = payload.results;
        state.totalBook = payload.count;
        state.next = payload.next;
        state.previous = payload.previous;
      })
      .addCase(getListOfBooksByAgeGroup.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload;
      })
      .addCase(searchBooksByQuery.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(searchBooksByQuery.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.bookList = payload.results;
        state.totalBook = payload.count;
        state.next = payload.next;
        state.previous = payload.previous;
      })
      .addCase(searchBooksByQuery.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload;
      })
      .addCase(getBookById.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getBookById.fulfilled, (state, { payload}) => {
        state.isLoading = false;
        state.selectedBook = payload;
      })
      .addCase(getBookById.rejected, (state, {payload}) => {
        state.isLoading = false;
        state.error = payload;
      });
  },
});

export const { setSelectedBook } = bookSelectionSlice.actions;
export default bookSelectionSlice.reducer;